var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { formatDistance } from 'date-fns';
var LocalizedDateFns = /** @class */ (function () {
    function LocalizedDateFns(uiConfig) {
        switch (uiConfig.locale) {
            case 'af':
                // FIXME: locale 'af' isn't available
                // this.localePromise = import('date-fns/locale/af');
                this.localePromise = Promise.resolve(undefined);
                break;
            case 'bn':
                // FIXME: locale 'bn' isn't available
                // this.localePromise = import('date-fns/locale/bn');
                this.localePromise = Promise.resolve(undefined);
                break;
            case 'ca':
                this.localePromise = import('date-fns/locale/ca');
                break;
            case 'cs':
                this.localePromise = import('date-fns/locale/cs');
                break;
            case 'da':
                this.localePromise = import('date-fns/locale/da');
                break;
            case 'de':
                this.localePromise = import('date-fns/locale/de');
                break;
            case 'es':
                this.localePromise = import('date-fns/locale/es');
                break;
            case 'el':
                this.localePromise = import('date-fns/locale/el');
                break;
            case 'fi':
                this.localePromise = import('date-fns/locale/fi');
                break;
            case 'fil':
                this.localePromise = import('date-fns/locale/fil');
                break;
            case 'fr':
                this.localePromise = import('date-fns/locale/fr');
                break;
            case 'hi':
                // FIXME: locale 'hi' isn't available
                // this.localePromise = import('date-fns/locale/hi');
                this.localePromise = Promise.resolve(undefined);
                break;
            case 'hu':
                // FIXME: locale 'hu' isn't available
                // this.localePromise = import('date-fns/locale/hu');
                this.localePromise = Promise.resolve(undefined);
                break;
            case 'id':
                this.localePromise = import('date-fns/locale/id');
                break;
            case 'it':
                this.localePromise = import('date-fns/locale/it');
                break;
            case 'ja':
                this.localePromise = import('date-fns/locale/ja');
                break;
            case 'ko':
                this.localePromise = import('date-fns/locale/ko');
                break;
            case 'ms':
                // FIXME: locale 'ms' isn't available
                // this.localePromise = import('date-fns/locale/ms');
                this.localePromise = Promise.resolve(undefined);
                break;
            case 'nb':
                this.localePromise = import('date-fns/locale/nb');
                break;
            case 'nl':
                this.localePromise = import('date-fns/locale/nl');
                break;
            case 'pl':
                this.localePromise = import('date-fns/locale/pl');
                break;
            case 'pt':
                this.localePromise = import('date-fns/locale/pt');
                break;
            case 'ro':
                this.localePromise = import('date-fns/locale/ro');
                break;
            case 'ru':
                this.localePromise = import('date-fns/locale/ru');
                break;
            case 'sl':
                // FIXME: locale 'sl' isn't available
                // this.localePromise = import('date-fns/locale/sl');
                this.localePromise = Promise.resolve(undefined);
                break;
            case 'sq':
                // FIXME: locale 'sq' isn't available
                // this.localePromise = import('date-fns/locale/sq');
                this.localePromise = Promise.resolve(undefined);
                break;
            case 'sv':
                this.localePromise = import('date-fns/locale/sv');
                break;
            case 'sw':
                // FIXME: locale 'sw' isn't available
                // this.localePromise = import('date-fns/locale/sw');
                this.localePromise = Promise.resolve(undefined);
                break;
            case 'th':
                this.localePromise = import('date-fns/locale/th');
                break;
            case 'tr':
                this.localePromise = import('date-fns/locale/tr');
                break;
            case 'uk':
                this.localePromise = import('date-fns/locale/en-GB');
                break;
            case 'vi':
                this.localePromise = import('date-fns/locale/vi');
                break;
            case 'zh':
                this.localePromise = import('date-fns/locale/zh-CN');
                break;
            case 'en':
                this.localePromise = Promise.resolve(undefined);
                break;
            default:
                this.localePromise = Promise.resolve(undefined);
                console.error("Locale " + uiConfig.locale + " isn't configure for date-fns: date won't be localized");
                break;
        }
    }
    LocalizedDateFns.prototype.formatDistance = function (date, baseDate, options) {
        return this.localePromise.then(function (locale) {
            return formatDistance(date, baseDate, __assign({}, options, { locale: locale }));
        });
    };
    return LocalizedDateFns;
}());
export { LocalizedDateFns };



// WEBPACK FOOTER //
// ./src/@freelancer/ui/localized-date-fns.service.ts.pre-build-optimizer.js